import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Edit } from './components'

const useStyles = makeStyles(theme => ({
    root: {},
    content: {
        padding: theme.spacing(3)
    }
}));

const UnSubscribeEdit = props => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <Edit />
            </div>
        </div>
    );
}

export default UnSubscribeEdit;